"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiInstance = exports.ApiError = void 0;
const axios_1 = __importDefault(require("axios"));
class ApiError extends Error {
    constructor({ error, message, statusCode }) {
        super(message);
        this.error = error;
        this.statusCode = statusCode;
    }
}
exports.ApiError = ApiError;
const methodWrapper = (method) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    try {
        const response = yield method();
        return {
            data: response.data
        };
    }
    catch (error) {
        const apiError = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        throw new ApiError({
            error: (_b = apiError === null || apiError === void 0 ? void 0 : apiError.error) !== null && _b !== void 0 ? _b : 'Unknown error',
            message: (_c = apiError === null || apiError === void 0 ? void 0 : apiError.message) !== null && _c !== void 0 ? _c : 'Internal Server Error',
            statusCode: (_d = apiError === null || apiError === void 0 ? void 0 : apiError.statusCode) !== null && _d !== void 0 ? _d : 500
        });
    }
});
const createApiInstance = (instanceConfig) => {
    const instance = axios_1.default.create(instanceConfig);
    return {
        get: (url, config) => methodWrapper(() => instance.get(url, config)),
        put: (url, data, config) => methodWrapper(() => instance.put(url, data, config)),
        post: (url, data, config) => methodWrapper(() => instance.post(url, data, config)),
        delete: (url, config) => methodWrapper(() => instance.delete(url, config)),
        configureRequest: (updatedConfig) => {
            instance.interceptors.request.use(config => (Object.assign(Object.assign({}, config), updatedConfig)));
        },
        instance
    };
};
exports.createApiInstance = createApiInstance;
